import type { SVGProps } from 'react';

const SvgGiftMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 8V21M12 8C11.6383 6.5094 11.0154 5.2355 10.2127 4.3436C9.41003 3.4517 8.46469 2.98363 7.5 3.00044C6.83696 3.00044 6.20107 3.26383 5.73223 3.73267C5.26339 4.20151 5 4.8374 5 5.50044C5 6.16348 5.26339 6.79936 5.73223 7.2682C6.20107 7.73705 6.83696 8.00044 7.5 8.00044M12 8C12.3617 6.5094 12.9846 5.2355 13.7873 4.3436C14.59 3.4517 15.5353 2.98363 16.5 3.00044C17.163 3.00044 17.7989 3.26383 18.2678 3.73267C18.7366 4.20151 19 4.8374 19 5.50044C19 6.16348 18.7366 6.79936 18.2678 7.2682C17.7989 7.73705 17.163 8.00044 16.5 8.00044M19 12V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V12M4 8H20C20.5523 8 21 8.44772 21 9V11C21 11.5523 20.5523 12 20 12H4C3.44772 12 3 11.5523 3 11V9C3 8.44772 3.44772 8 4 8Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgGiftMd;
